import { TimelineMax, Sine } from 'gsap'

export default {
  data () {
    return {
      tlNight: new TimelineMax({ paused: true })
    }
  },

  mounted () {
    this.tlNight
      .set('.star', { scale: 1.3 })
      .staggerTo('.star', 0.9, {
        scale: 0,
        transformOrigin: 'center center',
        ease: Sine.easeInOut,
        repeat: -1,
        yoyo: true,
        repeatDelay: 0.7
      }, 0.8)
  },
  beforeDestroy () {
    this.tlNight.kill()
  }
}



// WEBPACK FOOTER //
// ./src/mixins/timelines/night.js